// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1Z4-2","name":"ConsentHeader_name__3NHPz","birthday":"ConsentHeader_birthday__1zGLR","skeleton":"ConsentHeader_skeleton__QZs_u"};